export class StatusDto {
  code: string;
}